import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

const ScrollableContent = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '60vh',
  },
}));

const StyledModalContent = styled('div')(({ theme }) => ({
  display: 'grid',
  rowGap: theme.spacing(3),
  marginTop: theme.spacing(3),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '60vh',
  },
  [theme.breakpoints.down('xl')]: {
    paddingRight: theme.spacing(2),
  },
}));

export interface ModalContentProps {
  dataId?: string;
}

export const ModalContent: FC<ModalContentProps> = ({ dataId, children }) => {
  const { getTestIdProps } = useTestId();

  return (
    <ScrollableContent>
      <StyledModalContent {...getTestIdProps(`${dataId ?? 'modal-container'}`)}>
        {children}
      </StyledModalContent>
    </ScrollableContent>
  );
};
